import { useEffect, useState, useCallback } from 'sb-hooks'
import { getCouponData } from 'actions/coupon'


type useRecurlyCouponQueryProps = {
  coupon: string
  skip?: boolean
}

type ReturnType = {
  product: GiftOfferModal.ProductType
  isFetching: boolean
  fetch: () => void
}


const useRecurlyCouponQuery = (props: useRecurlyCouponQueryProps): ReturnType => {
  const { coupon, skip } = props

  const [ { product, isFetching }, setState ] = useState({
    product: null,
    isFetching: !skip,
  })

  const fetch = useCallback(() => {
    setState({ isFetching: true })

    getCouponData({ couponCode: coupon })
      .then(
        ({ data }) => {
          const { rating, ...productData } = data ? data.freeProduct : {}

          const product = data ? {
            ...productData,
            rating: rating.avgRate,
          } : null

          setState({ product, isFetching: false })
        },
        () => setState({ isFetching: false })
      )
  }, [ coupon ])

  useEffect(() => {
    if (!skip) {
      fetch()
    }
  }, [ skip, fetch ])

  return {
    product,
    isFetching,
    fetch,
  }
}


export default useRecurlyCouponQuery
